import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import user from "./modules/user";
import users from "./modules/users";
import server from "./modules/server";
import settings from "./modules/settings";
import defaultClient from "./modules/defaultClient";
import holidayInfo from "./modules/holidayInfo";
import absences from "./modules/absences";
import bookingLines from "./modules/bookingLines";
import language from "./modules/language";
import simpleClient from "./modules/simpleClient";
import userRights from "./modules/userRights";
import mobile from "./modules/mobile";
import userSettings from "./modules/users/userSettings";
import eventLogs from "./modules/eventLogs";
import fs from "./modules/fs";
import reporting from "./modules/reporting";

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    users,
    userSettings,
    server,
    settings,
    defaultClient,
    holidayInfo,
    absences,
    bookingLines,
    language,
    simpleClient,
    userRights,
    mobile,
    fs,
    reporting,
    eventLogs
  },
  getters: {
    status: (state) => state.status
  }
});
